//@ts-check
import React from 'react';
import { useTheme } from '@material-ui/core/styles';
/**
 * @param {import('./types').FilterExpressionFormGroupProps } props
 */

var FilterExpressionFormGroup = function FilterExpressionFormGroup(_ref) {
  var children = _ref.children,
      group = _ref.group;
  var theme = useTheme();
  return React.createElement("div", {
    style: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      borderLeft: "".concat(theme.spacing(0.5), "px solid ").concat(theme.palette.divider)
    } // title={group.Group}

  }, children);
};

FilterExpressionFormGroup.defaultProps = {};
export default FilterExpressionFormGroup;